// Static content for Gremlin Coffee landing site.

export const ASSETS = {
  mascot: "https://customer-assets-jai6qajn.emergentagent.net/job_creamy-roast/artifacts/8o8oqcab_Icon%20Mark.jpg",
  logo: "https://customer-assets-jai6qajn.emergentagent.net/job_creamy-roast/artifacts/xm47hftv_Primary%20Logo.jpg",
  packaging: "https://customer-assets-jai6qajn.emergentagent.net/job_creamy-roast/artifacts/1uadsbn0_Packaging.png",
  merchMockup: "https://customer-assets-jai6qajn.emergentagent.net/job_creamy-roast/artifacts/kyhikvze_Merch%20Mockup.png",
  beansMoody: "https://images.unsplash.com/photo-1620820186187-fc32e79adb74?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  beansScoop: "https://images.unsplash.com/photo-1585349048460-e5f5684331a1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  martini: "https://images.pexels.com/photos/15389024/pexels-photo-15389024.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  martini2: "https://images.unsplash.com/photo-1607687633950-c745bdb4da70?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  pour: "https://images.unsplash.com/photo-1609050471053-8636409f9f5b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const FLAVORS = [
  {
    id: "gremlin-tavern",
    name: "Gremlin Tavern",
    tagline: "Notes of rich chocolate and smoky whiskey warmth on the finish. Trouble, brewed.",
    notes: ["Chocolate", "Whiskey", "Oak"],
    accent: "#C4761E",
    featured: true,
  },
  {
    id: "gremlin-island",
    name: "Gremlin Island",
    tagline: "A tropical escape with hints of French vanilla, hazelnut and toasted coconut.",
    notes: ["French Vanilla", "Hazelnut", "Toasted Coconut"],
    accent: "#D9A15A",
  },
  {
    id: "morning-mayhem",
    name: "Morning Mayhem",
    tagline: "A bright, easy breakfast blend to start the chaos right.",
    notes: ["Breakfast Blend", "Bright", "Clean"],
    accent: "#E8A94A",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "AIR, NOT FIRE",
    body: "We air-roast every bean, suspended in a bed of hot air instead of scorched on hot metal. The chaff (the bean's papery skin) simply falls away in the airflow. In a traditional drum roaster it burns right into the coffee, and that char is where the bitterness comes from.",
  },
  {
    n: "02",
    title: "SMOOTH BY DESIGN",
    body: "No burnt chaff, no scorched metal, no harsh bite. Air roasting strips the bitterness out at the source, so the cup just tastes clean.",
  },
  {
    n: "03",
    title: "INFUSED, NOT FAKED",
    body: "The roast comes first. Then, while the beans are still warm, we infuse them with real flavor, so a chocolate-whiskey cup or an espresso martini tastes indulgent without the guilt.",
  },
  {
    n: "04",
    title: "NASHVILLE TO EVERYWHERE",
    body: "Roasted in Nashville, shipped fresh across North America. Small-batch, mischievous, and built to grow into something way bigger than a bag of beans.",
  },
];

export const MARTINI_STEPS = [
  { step: "01", text: "Brew a double shot (2 oz) of any Gremlin bean. Tavern makes it a chocolate-whiskey martini. Chill it fast." },
  { step: "02", text: "Add 2 oz vodka, 1 oz coffee liqueur, 0.5 oz simple syrup to a shaker." },
  { step: "03", text: "Pour in the chilled espresso. Fill with ice. Shake it hard. You want the foam." },
  { step: "04", text: "Double strain into a coupe. Float three beans on top. Cause trouble." },
];

// Flip to true when ready to accept orders (Shopify payments + prices set)
export const SHOP_OPEN = false;

// Flip to true when merch is stocked in Shopify (handles: tee, trucker, tote, mug)
export const MERCH_AVAILABLE = false;

export const MERCH = [
  { id: "tee", name: "Air Roasted Tee", price: 32, tag: "Heavyweight cotton" },
  { id: "trucker", name: "Gremlin Trucker", price: 28, tag: "Burnt orange / mesh" },
  { id: "tote", name: "Canvas Tote", price: 22, tag: "Natural / screen print" },
  { id: "mug", name: "Ceramic Mug", price: 18, tag: "12oz / badge print" },
];

export const FLAVOR_IMAGES = {
  "gremlin-tavern": "https://static.prod-images.emergentagent.com/jobs/91557657-00c4-4db7-aff2-3b75e70a750b/images/f1c738c3dbb052cd4badae74fbb31a333ea414e58f34e9ffae4c4764daac8a0b.jpeg",
  "gremlin-island": "https://static.prod-images.emergentagent.com/jobs/91557657-00c4-4db7-aff2-3b75e70a750b/images/c4346b955e515eea3674765c8186dd53ae4a91d328d7c46517da0978c7be6616.jpeg",
  "morning-mayhem": "https://static.prod-images.emergentagent.com/jobs/91557657-00c4-4db7-aff2-3b75e70a750b/images/8891d8fed0725b852000959a3be813c953e78d879cc48855f2e49390902b7902.jpeg",
};

export const GREMLIN_PERSONAS = [
  { id: "gremlin-tavern", title: "The Barkeep", blurb: "Knows your order, keeps your secrets, closes the tab at dawn." },
  { id: "gremlin-island", title: "The Vacation Enforcer", blurb: "Mandatory hula breaks. Out of office forever." },
  { id: "morning-mayhem", title: "The Alarm Clock", blurb: "Physically incapable of a quiet morning. Chaos first, breakfast second." },
];

export const LAUNCH_DATE = "2026-10-01T08:00:00-05:00";

export const QUIZ = [
  {
    q: "When does the chaos start?",
    options: [
      { label: "5:00 AM. On purpose.", scores: { "morning-mayhem": 2 } },
      { label: "After the second cup.", scores: { "gremlin-island": 2 } },
      { label: "When the sun goes down.", scores: { "gremlin-tavern": 2 } },
      { label: "It never stops.", scores: { "morning-mayhem": 1, "gremlin-tavern": 1 } },
    ],
  },
  {
    q: "Pick a weekend.",
    options: [
      { label: "Campfire in the Smokies.", scores: { "gremlin-tavern": 1, "morning-mayhem": 1 } },
      { label: "Beach chair, phone off.", scores: { "gremlin-island": 2 } },
      { label: "Bar crawl on Broadway.", scores: { "gremlin-tavern": 2 } },
      { label: "Finishing a project at 2am.", scores: { "morning-mayhem": 2 } },
    ],
  },
  {
    q: "How do you take your coffee?",
    options: [
      { label: "Black. Obviously.", scores: { "gremlin-tavern": 2 } },
      { label: "Drowning in cream.", scores: { "gremlin-island": 2 } },
      { label: "Like a dessert.", scores: { "gremlin-tavern": 1, "gremlin-island": 1 } },
      { label: "Shaken, in a coupe.", scores: { "gremlin-tavern": 2 } },
    ],
  },
  {
    q: "Your gremlin energy is…",
    options: [
      { label: "Sunshine with claws.", scores: { "morning-mayhem": 1, "gremlin-island": 1 } },
      { label: "Cozy little menace.", scores: { "gremlin-tavern": 2 } },
      { label: "Smooth operator.", scores: { "gremlin-tavern": 1, "gremlin-island": 1 } },
      { label: "Feral. Unstoppable.", scores: { "morning-mayhem": 2 } },
    ],
  },
  {
    q: "Pick a treat.",
    options: [
      { label: "Whiskey-filled chocolate.", scores: { "gremlin-tavern": 2 } },
      { label: "Toasted coconut macaroon.", scores: { "gremlin-island": 2 } },
      { label: "Dark chocolate, straight.", scores: { "gremlin-tavern": 2 } },
      { label: "A warm cinnamon roll.", scores: { "morning-mayhem": 2 } },
    ],
  },
];

export const JOURNAL = [
  {
    slug: "why-air-roasting-changes-everything",
    title: "Why Air Roasting Changes Everything",
    tag: "The Craft",
    date: "June 12, 2026",
    read: "4 min",
    cover: "https://static.prod-images.emergentagent.com/jobs/91557657-00c4-4db7-aff2-3b75e70a750b/images/79f97252413381e7f4972a00c4198f921b4a00e82b3cb044e561b162d95b7b3a.jpeg",
    excerpt: "Most coffee is scorched on hot metal. Ours floats on a bed of hot air. Here's why that one difference is the whole brand.",
    body: [
      "Walk into almost any roastery in America and you'll find a drum roaster, a big rotating metal barrel over a flame. Beans tumble against scorching steel, and some of them burn. That charred, bitter edge in most coffee isn't boldness. It's scorch.",
      "Air roasting works differently. The beans never touch hot metal. They're suspended and tumbled on a column of hot air, so every bean roasts evenly on all sides with zero contact burn. And the chaff, that papery skin on every bean, simply falls off and gets blown away in the airflow. In a drum roaster it has nowhere to go: it burns against the hot metal and cooks right into your coffee, which is exactly where that acrid, bitter edge comes from.",
      "The result is the smoothest coffee most people have ever tasted. There's no bitter bite to bury under sugar and no harshness to hide with syrup. It's also why our infused flavors work so well: the bean is a clean canvas, so the real chocolate, whiskey and coconut notes come through honest.",
      "We've been perfecting this in Nashville, one small batch at a time. And here's a bonus most people don't expect: because there's no burnt edge to turn stale and sour, yesterday's leftover pot makes excellent iced coffee the next day. Just pour it over ice. Zero waste. Once you've had air-roasted, drum coffee tastes like the campfire ash instead of the s'more.",
    ],
  },
  {
    slug: "the-espresso-martini-gremlin-ified",
    title: "The Espresso Martini, Gremlin-ified",
    tag: "After Dark",
    date: "June 5, 2026",
    read: "3 min",
    cover: FLAVOR_IMAGES["gremlin-tavern"],
    excerpt: "The secret to a great espresso martini isn't the vodka. It's the bean. And the bean can bring the flavor for you.",
    body: [
      "Every bar in Nashville pours espresso martinis now. Most of them taste like sweetened regret, because they start with bitter espresso and fix it with sugar syrup.",
      "Here's our move: start with a bean that doesn't need fixing. Ours are air-roasted, so the shot pulls bold and syrupy with zero bitterness. No sugar-syrup rescue required.",
      "But the real mischief? Brew your shot with an infused bean. Gremlin Tavern turns the drink into a chocolate-whiskey martini before the vodka even shows up. The flavor is the foundation, infused into the bean, so there are no bottles of flavor syrup cluttering your counter.",
      "Shake it harder than feels reasonable. Foam is the whole point. Three beans on top. Cause trouble responsibly.",
    ],
  },
  {
    slug: "nashville-is-the-flavor",
    title: "Nashville Is the Flavor",
    tag: "The Brand",
    date: "May 28, 2026",
    read: "3 min",
    cover: "https://static.prod-images.emergentagent.com/jobs/91557657-00c4-4db7-aff2-3b75e70a750b/images/80129698b51748d857ef1bddbec7e947869846d95d5283f733691f4c43ed91b0.jpeg",
    excerpt: "Music City runs on late nights and early mornings. Gremlin Coffee was built for both.",
    body: [
      "Nashville doesn't sip politely. It writes songs until 3am, opens the coffee shop at 6, and does it all again tomorrow. That rhythm, a little chaotic and a lot alive, is the whole personality of this brand.",
      "We're small-batch by design. Every batch is air-roasted right here in Nashville, then shipped fresh across North America. No warehouse staleness, no six-month-old beans in a pretty bag.",
      "The gremlin on the bag is the honest mascot of that lifestyle: mischievous, a little unhinged before the first cup, unstoppable after it. Morning Mayhem for the school run. Island for the mental vacation. Tavern for the nightcap.",
      "This is bigger than beans. It's a flag for people who like their coffee smooth and their days a little feral.",
    ],
  },
  {
    slug: "a-lifestyle-brand-manifesto",
    title: "Merch Before Empire: A Lifestyle Brand Manifesto",
    tag: "The Brand",
    date: "May 15, 2026",
    read: "2 min",
    cover: ASSETS.merchMockup,
    excerpt: "Why a coffee company makes trucker hats: because a brand you wear is a brand you believe in.",
    body: [
      "Nobody needs another coffee company. People need something to belong to. That's why Gremlin Coffee offers tees, truckers, totes and mugs right alongside the beans. They're sold separately and ship in their own box, so your gear never holds up your coffee.",
      "The badge on the bag (AIR ROASTED, split gremlin head, burnt orange on black) was designed to live outside the kitchen. On a cap at the farmers market. On a tote full of vinyl. On the mug that never gets washed because it's 'seasoned.'",
      "Every piece is heavyweight, screen-printed, and built to outlast the trend cycle. Wear the gremlin, and you're telling the world two things: your coffee is smooth, and your energy is not.",
    ],
  },
];

export const FLAVOR_DETAILS = {
  "gremlin-tavern": {
    roast: "Medium-dark roast · flavor infused",
    story: "Notes of rich chocolate and smoky whiskey warmth, infused into the bean right after the air roast while it's still warm, so the flavor soaks in instead of sitting on top. Zero actual booze (until you add it). It's great coffee first, with the chocolate and oak riding the finish of every sip.",
    brew: [
      "French press brings out the oak and chocolate body.",
      "A splash of cream rounds the whiskey note into caramel territory.",
      "Outstanding as the espresso base of a chocolate-whiskey martini.",
    ],
    pairing: "Pairs with: leather chairs, vinyl records, and one more round.",
  },
  "gremlin-island": {
    roast: "Medium roast · flavor infused",
    story: "A tropical escape in a 12oz bag. French vanilla, hazelnut and toasted coconut are infused straight into the bean. Smooth coffee up front, a gentle hint of the tropics on the finish.",
    brew: [
      "Incredible iced with coconut milk or cold foam.",
      "Hot pour-over lets the vanilla lead; French press pushes the hazelnut forward.",
      "Try it as the base of an iced latte. No flavor syrup needed.",
    ],
    pairing: "Pairs with: sunshine, beach chairs, and pretending you're not checking email.",
  },
  "morning-mayhem": {
    roast: "Light-medium roast · breakfast blend",
    story: "A bright, clean breakfast blend built to start the chaos right. Higher in natural caffeine, easy on the palate, and smooth enough to drink black, even for the cream and sugar crowd.",
    brew: [
      "Drip machine friendly. Set it the night before and wake up to mayhem.",
      "Great at a 1:15 ratio for a brighter, juicier cup.",
      "Makes a killer iced coffee that stays crisp, not sour.",
    ],
    pairing: "Pairs with: alarm clocks, school runs, and conquering your inbox.",
  },
};

export const RECIPES = [
  {
    id: "tavern-martini",
    name: "Tavern Espresso Martini",
    flavorId: "gremlin-tavern",
    type: "cocktail",
    time: "5 min",
    ingredients: ["2 oz chilled Gremlin Tavern espresso", "2 oz vodka", "1 oz coffee liqueur", "0.5 oz simple syrup", "3 coffee beans to garnish"],
    steps: [
      "Brew Tavern strong (espresso or moka pot) and chill it fast.",
      "Add everything to a shaker packed with ice.",
      "Shake harder than feels reasonable. Foam is the whole point.",
      "Double strain into a coupe and float three beans on top.",
    ],
    note: "Gremlin Tavern brings the chocolate and smoky warmth straight from the bean.",
  },
  {
    id: "tavern-nightcap",
    name: "Tavern Nightcap",
    flavorId: "gremlin-tavern",
    type: "cocktail",
    time: "8 min",
    ingredients: ["3 oz chilled Gremlin Tavern cold brew", "1.5 oz bourbon", "2 dashes chocolate bitters", "Orange peel", "Big ice cube"],
    steps: [
      "Brew Tavern as cold brew, or chill a strong French press batch.",
      "Stir cold brew, bourbon and bitters over ice for 20 seconds.",
      "Strain over a big cube in a rocks glass.",
      "Express the orange peel over the top and drop it in.",
    ],
    note: "The chocolate and oak in the bean meet actual bourbon. The after-dark pour.",
  },
  {
    id: "island-cold-brew",
    name: "Island Coconut Cold Brew",
    flavorId: "gremlin-island",
    type: "brew",
    time: "12 hrs (mostly waiting)",
    ingredients: ["1 cup coarse-ground Gremlin Island", "4 cups cold filtered water", "Coconut milk or cold foam", "Ice"],
    steps: [
      "Steep grounds in cold water for 12–16 hours in the fridge.",
      "Strain through a fine filter, twice if you're fancy.",
      "Pour over ice and top with coconut milk or coconut cold foam.",
      "Garnish with toasted coconut if you're showing off.",
    ],
    note: "The vanilla, hazelnut and coconut come straight from the bean.",
  },
  {
    id: "mayhem-shaker",
    name: "Morning Mayhem Iced Shaker",
    flavorId: "morning-mayhem",
    type: "brew",
    time: "6 min",
    ingredients: ["6 oz double-strength Morning Mayhem (brewed hot)", "Big handful of ice", "Splash of cream or oat milk", "Keto vanilla syrup, optional"],
    steps: [
      "Brew Mayhem at double strength so the ice can't water it down.",
      "Pour it straight into a shaker full of ice.",
      "Shake 15 seconds. It chills, aerates and gets frothy.",
      "Strain over fresh ice, splash in cream, start the chaos.",
    ],
    note: "Shaking hot coffee over ice makes instant Japanese-style iced coffee with foam.",
  },
];
